function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.49,
    height: 15.85,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.98125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 7.925,
    fontFamily: "Arial"
  }, "\n        Red_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.85,
    width: 26.49,
    height: 15.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.99625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 23.835,
    fontFamily: "Arial"
  }, "\n        Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.82,
    width: 26.49,
    height: 16.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9758823529411764
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 40.115,
    fontFamily: "Arial"
  }, "\n        Lake_of_the_Woods\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 48.41,
    width: 26.49,
    height: 16.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.10875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 56.845,
    fontFamily: "Arial"
  }, "\n        Mahnomen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 65.28,
    width: 26.49,
    height: 20,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.857142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 75.28,
    fontFamily: "Arial"
  }, "\n        Kittson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 85.28,
    width: 26.49,
    height: 21.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 95.975,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.67,
    width: 26.49,
    height: 22.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.511111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 117.97,
    fontFamily: "Arial"
  }, "\n        Big_Stone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 129.27,
    width: 26.49,
    height: 24.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5585714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 141.72500000000002,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 154.18,
    width: 26.49,
    height: 25.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.178333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 166.715,
    fontFamily: "Arial"
  }, "\n        Wilkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 179.24,
    width: 26.49,
    height: 27.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.298
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 192.985,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 206.73,
    width: 26.49,
    height: 27.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 220.54,
    fontFamily: "Arial"
  }, "\n        Norman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 234.34,
    width: 26.49,
    height: 29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.649
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 248.84,
    fontFamily: "Arial"
  }, "\n        Clearwater\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 263.35,
    width: 26.49,
    height: 33.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0376923076923075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 280.235,
    fontFamily: "Arial"
  }, "\n        Lac_qui_Parle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 297.12,
    width: 26.49,
    height: 36.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 315.145,
    fontFamily: "Arial"
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 333.17,
    width: 26.49,
    height: 37.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 351.73,
    fontFamily: "Arial"
  }, "\n        Pipestone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 370.29,
    width: 26.49,
    height: 38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 389.29,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 408.29,
    width: 26.49,
    height: 38.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.31125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 427.76,
    fontFamily: "Arial"
  }, "\n        Watonwan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 447.23,
    width: 26.49,
    height: 39.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.31125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 466.945,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 486.66,
    width: 26.49,
    height: 41.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.298
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 507.28000000000003,
    fontFamily: "Arial"
  }, "\n        Swift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 527.89,
    width: 26.49,
    height: 41.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7842857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 548.51,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 569.14,
    width: 26.49,
    height: 41.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7659999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 590.055,
    fontFamily: "Arial"
  }, "\n        Yellow_Medicine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 610.97,
    width: 26.49,
    height: 43.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7842857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 632.7850000000001,
    fontFamily: "Arial"
  }, "\n        Stevens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 654.59,
    width: 26.49,
    height: 45.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.245,
    y: 677.2950000000001,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 0,
    width: 32.54,
    height: 38.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.254
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.76,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Cottonwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.03,
    y: 0,
    width: 33.27,
    height: 38.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3270000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.665,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Pennington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 0,
    width: 33.44,
    height: 38.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.02,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.74,
    y: 0,
    width: 33.6,
    height: 38.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.54,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Wadena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.33,
    y: 0,
    width: 34.55,
    height: 38.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.6375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.60500000000002,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.88,
    y: 0,
    width: 35.85,
    height: 38.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.121428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.805,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Kanabec\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.74,
    y: 0,
    width: 36.21,
    height: 38.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.291818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.845,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Koochiching\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.95,
    y: 0,
    width: 37.72,
    height: 38.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.286666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.81,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Roseau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.67,
    y: 0,
    width: 38.61,
    height: 38.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.361666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.975,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Sibley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.28,
    y: 0,
    width: 40.79,
    height: 38.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.452857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.67499999999995,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Redwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.07,
    y: 0,
    width: 42.38,
    height: 38.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.634
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.26,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.45,
    y: 0,
    width: 42.76,
    height: 38.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.77125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.83,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Renville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.2,
    y: 0,
    width: 43.48,
    height: 38.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.361666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.94,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Aitkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.68,
    y: 0,
    width: 44.35,
    height: 38.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2411111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.855,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Faribault\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.03,
    y: 0,
    width: 46.66,
    height: 38.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.361666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.36,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Waseca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.69,
    y: 0,
    width: 46.7,
    height: 38.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.361666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.0400000000001,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Nobles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 649.4,
    y: 0,
    width: 50.6,
    height: 38.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.452857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.6999999999999,
    y: 19.085,
    fontFamily: "Arial"
  }, "\n        Hubbard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 38.17,
    width: 50.12,
    height: 40.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.822857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 58.55,
    fontFamily: "Arial"
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 78.93,
    width: 50.12,
    height: 40.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 99.42,
    fontFamily: "Arial"
  }, "\n        Fillmore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 119.91,
    width: 50.12,
    height: 41.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 140.46,
    fontFamily: "Arial"
  }, "\n        Mille_Lacs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 161.01,
    width: 50.12,
    height: 41.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.928333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 181.795,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 202.58,
    width: 50.12,
    height: 42.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.031428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 223.69,
    fontFamily: "Arial"
  }, "\n        Wabasha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 244.8,
    width: 50.12,
    height: 42.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 266.19,
    fontFamily: "Arial"
  }, "\n        Meeker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 287.58,
    width: 50.12,
    height: 44.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 309.81,
    fontFamily: "Arial"
  }, "\n        Todd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 332.05,
    width: 50.12,
    height: 46.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 355.08000000000004,
    fontFamily: "Arial"
  }, "\n        Lyon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 378.1,
    width: 50.12,
    height: 49.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 402.815,
    fontFamily: "Arial"
  }, "\n        Le_Sueur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 427.53,
    width: 50.12,
    height: 51.45,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.024
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 453.255,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 478.98,
    width: 50.12,
    height: 52.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 505.175,
    fontFamily: "Arial"
  }, "\n        Pine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 531.37,
    width: 50.12,
    height: 54.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 558.615,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 585.86,
    width: 50.12,
    height: 56.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 614.2,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 642.54,
    width: 50.12,
    height: 57.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.353333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.55,
    y: 671.27,
    fontFamily: "Arial"
  }, "\n        Becker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 38.17,
    width: 52.16,
    height: 56.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.69,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Morrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.77,
    y: 38.17,
    width: 52.98,
    height: 56.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.26000000000002,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Benton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.75,
    y: 38.17,
    width: 53.05,
    height: 56.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.841666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.275,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Isanti\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.8,
    y: 38.17,
    width: 53.59,
    height: 56.54,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.655714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.595,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Carlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.39,
    y: 38.17,
    width: 54.47,
    height: 56.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.625,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Nicollet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.86,
    y: 38.17,
    width: 54.7,
    height: 56.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.116666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.21000000000004,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        McLeod\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.56,
    y: 38.17,
    width: 57.09,
    height: 56.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.423333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.105,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Steele\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.65,
    y: 38.17,
    width: 57.35,
    height: 56.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.325,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Freeborn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.01,
    y: 38.17,
    width: 61.14,
    height: 56.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.077142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.58,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.15,
    y: 38.17,
    width: 61.18,
    height: 56.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.74,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Beltrami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.33,
    y: 38.17,
    width: 65.67,
    height: 56.54,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.308
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.1650000000001,
    y: 66.44,
    fontFamily: "Arial"
  }, "\n        Mower\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 94.71,
    width: 71.06,
    height: 54.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.058888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.14,
    y: 121.975,
    fontFamily: "Arial"
  }, "\n        Kandiyohi\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 149.24,
    width: 71.06,
    height: 61.4,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.14,
    y: 179.94,
    fontFamily: "Arial"
  }, "\n        Itasca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 210.64,
    width: 71.06,
    height: 62.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.881428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.14,
    y: 241.725,
    fontFamily: "Arial"
  }, "\n        Chisago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 272.81,
    width: 71.06,
    height: 62.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.14,
    y: 304.275,
    fontFamily: "Arial"
  }, "\n        Goodhue\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 335.74,
    width: 71.06,
    height: 66.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.5125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.14,
    y: 368.765,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 401.78,
    width: 71.06,
    height: 67.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.271666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.14,
    y: 435.59499999999997,
    fontFamily: "Arial"
  }, "\n        Winona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 469.41,
    width: 71.06,
    height: 73.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.14,
    y: 506.20000000000005,
    fontFamily: "Arial"
  }, "\n        Rice\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 542.99,
    width: 71.06,
    height: 77.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.106
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.14,
    y: 581.73,
    fontFamily: "Arial"
  }, "\n        Blue_Earth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.61,
    y: 620.47,
    width: 71.06,
    height: 79.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.895555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.14,
    y: 660.235,
    fontFamily: "Arial"
  }, "\n        Crow_Wing\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.68,
    y: 94.71,
    width: 65.36,
    height: 87.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.36,
    y: 138.53,
    fontFamily: "Arial"
  }, "\n        Otter_Tail\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.04,
    y: 94.71,
    width: 70.69,
    height: 87.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.854444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.385,
    y: 138.53,
    fontFamily: "Arial"
  }, "\n        Sherburne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.73,
    y: 94.71,
    width: 80.29,
    height: 87.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.381666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.875,
    y: 138.53,
    fontFamily: "Arial"
  }, "\n        Carver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.02,
    y: 94.71,
    width: 99.42,
    height: 87.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.606666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.72999999999996,
    y: 138.53,
    fontFamily: "Arial"
  }, "\n        Wright\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.44,
    y: 94.71,
    width: 100.4,
    height: 87.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.528
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.64,
    y: 138.53,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.84,
    y: 94.71,
    width: 136.16,
    height: 87.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 631.9200000000001,
    y: 138.53,
    fontFamily: "Arial"
  }, "\n        Olmsted\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.68,
    y: 182.35,
    width: 107.5,
    height: 116.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.357142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.43,
    y: 240.73499999999999,
    fontFamily: "Arial"
  }, "\n        Stearns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.68,
    y: 299.13,
    width: 107.5,
    height: 200.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.43,
    y: 399.135,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.68,
    y: 499.14,
    width: 107.5,
    height: 200.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.772727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.43,
    y: 599.5699999999999,
    fontFamily: "Arial"
  }, "\n        Saint_Louis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 182.35,
    width: 197.56,
    height: 148.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 29.619999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.96000000000004,
    y: 256.4,
    fontFamily: "Arial"
  }, "\n        Anoka\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.74,
    y: 182.35,
    width: 247.26,
    height: 148.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.683333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.37,
    y: 256.4,
    fontFamily: "Arial"
  }, "\n        Dakota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 330.45,
    width: 132.82,
    height: 369.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.136666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.59000000000003,
    y: 515.225,
    fontFamily: "Arial"
  }, "\n        Ramsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.99,
    y: 330.45,
    width: 312.01,
    height: 369.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.00125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.995,
    y: 515.225,
    fontFamily: "Arial"
  }, "\n        Hennepin\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2000);
export default __webpack_public_path__ + "static/media/2000.402ad9930fdc993bcffa9c590de403bb.svg";
export { ForwardRef as ReactComponent };